import React, { useState, createElement, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import PaperLms from '../../../assets/images/logo/paperlms.png';

import { useSelector } from 'react-redux';

import {
    Layout,
    Button,
    Row,
    Col,
} from "antd";
import {
    RiMenuFoldLine,
    RiMenuUnfoldLine,
} from "react-icons/ri";

import MenuLogo from "./logo";
import MenuItem from "./item";
import MenuMobile from "./mobile";

const { Sider } = Layout;

export default function Sidebar(props) {
    const { visible, setVisible } = props;

    // Redux
    const customise = useSelector(state => state.customise)

    // Collapsed
    const [collapsed, setCollapsed] = useState(false);

    useEffect(() => {
        if (customise.sidebarCollapsed) {
            setCollapsed(true);
        } else {
            setCollapsed(false);
        }
    }, [customise])

    // Location
    const location = useLocation();
    const { pathname } = location;

    // Mobile Sidebar
    const onClose = () => {
        setVisible(false);
    };

    // Menu
    function toggle() {
        setCollapsed(!collapsed);
    }

    const trigger = createElement(
        collapsed ? RiMenuUnfoldLine : RiMenuFoldLine,
        {
            className: "trigger",
            onClick: toggle,
        }
    );

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={256}
            className="da-sidebar da-bg-color-black-0 da-bg-color-dark-100"
        >
            <Row className="da-mr-12 da-ml-24 da-mt-24" align="top" justify="end">
           
                <Col className="csm-img-logo">
                {collapsed === false ? <MenuLogo onClose={onClose} /> : ""}
                {
                    customise.sidebarCollapseButton && (
                        <Col className="da-pr-0 da-mr-auto csm-sidemenu-button da-mb-auto">
                            
                            <Button
                                icon={trigger}
                                type="text"
                                className="da-float-right  da-text-color-dark-0"
                            />
                          
                        </Col>
                    )
                }
                   
                
              
                </Col>
              

            </Row>

            <MenuItem onClose={onClose} />

            <MenuMobile onClose={onClose} visible={visible} />
                
            {/* <Col>
                {collapsed === false ? (
                    <div className="sidebar__footer">
                        <span>Powered by</span>
                        <img style={{width:'60%'}} src={PaperLms} alt="paperlms" />
                    </div>
                ) : ""}
            </Col> */}
        </Sider>
    );
};
